// Cryptographic identity types. A PublicKey is self-describing key material
// (suite name + raw bytes). A KeyId is a compact, suite-agnostic hash of a
// serialized PublicKey, used as a stable peer identifier across the system.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { stringToUint8Array } from './hashing.js';
import { getSigningSuite } from './registry.js';
export function serializePublicKey(pk) {
    const suiteBytes = stringToUint8Array(pk.suite);
    const lenBuf = new Uint8Array(4);
    new DataView(lenBuf.buffer).setUint32(0, suiteBytes.length, false);
    const result = new Uint8Array(4 + suiteBytes.length + pk.key.length);
    result.set(lenBuf, 0);
    result.set(suiteBytes, 4);
    result.set(pk.key, 4 + suiteBytes.length);
    return result;
}
export function deserializePublicKey(bytes) {
    const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    const suiteLen = view.getUint32(0, false);
    const suiteBytes = bytes.subarray(4, 4 + suiteLen);
    const suite = new TextDecoder().decode(suiteBytes);
    const key = bytes.subarray(4 + suiteLen);
    return { suite, key: new Uint8Array(key) };
}
export function keyIdFromPublicKey(pk, hash) {
    return hash.hashToB64(serializePublicKey(pk));
}
export function createIdentity(signingName, hashSuite) {
    return __awaiter(this, void 0, void 0, function* () {
        const suite = getSigningSuite(signingName);
        if (!suite)
            throw new Error(`signing suite not found: ${signingName}`);
        const kp = yield suite.generateKeyPair();
        const publicKey = { suite: signingName, key: kp.publicKey };
        const keyId = keyIdFromPublicKey(publicKey, hashSuite);
        return { publicKey, secretKey: kp.secretKey, keyId };
    });
}
